import styled from 'styled-components';
import { PAGE_SIDE_PADDING } from '../../styles/Layout';
import { ThemeColours } from '../../styles/ThemeColours';
import { Breakpoint, FontSize, FontWeight, FONT_STACK, PRESSABLE } from '../../styles/constants';
import { Link } from '../Link';
import { IconGPTopNav } from '../icons/IconGPTopNav';
import { IconHealthEngine } from '../icons/IconHealthEngine';
import { IconTelehealthTopNav } from '../icons/IconTelehealthTopNav';
import { OverflowSpecialtyOption } from './SpecialtyOption/OverflowSpecialtyOption';
import { SpecialtyOption } from './SpecialtyOption/SpecialtyOption';

export const TOP_NAVIGATION_BAR_HEIGHT = '60px';

export const TOP_NAVIGATION_BAR_HEIGHT_WITH_HEADER = '164px';

export const TopNavContainer = styled.div`
  display: none;

  ${Breakpoint.MEDIUM} {
    ${FONT_STACK}
    align-items: center;
    background-color: ${ThemeColours.white};
    border-bottom: 1px solid ${ThemeColours.mono300};
    box-sizing: border-box;
    display: flex;
    flex-flow: row;
    height: ${TOP_NAVIGATION_BAR_HEIGHT};
    padding-left: ${PAGE_SIDE_PADDING};
    position: relative;
    width: 100%;
  }
`;

export const TopNavContainerVariant2 = styled(TopNavContainer)`
  ${Breakpoint.SMALL} {
    background-color: ${ThemeColours.primary600};
  }
`;

export const SpecialtiesContainer = styled.div`
  align-items: center;
  color: ${ThemeColours.mono800};
  display: flex;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  gap: 20px;
  justify-content: center;
  margin-left: 16px;
`;

export const OverflowSpecialtiesContainer = styled(SpecialtiesContainer)`
  margin-left: 0;
`;

export const GPSpecialtiesContainer = styled(SpecialtiesContainer)`
  border-right: 1px solid ${ThemeColours.mono200};
  gap: 22px;
  height: 24px;
  margin-left: 7px;
  padding-right: 16px;
`;

export const Specialty = styled(SpecialtyOption)`
  display: flex;
  flex-wrap: wrap;
`;

export const SpecialtyVariant2 = styled(Specialty)`
  color: ${ThemeColours.white};

  &:visited,
  &:active,
  &:link {
    color: ${ThemeColours.white};
  }

  &:hover {
    color: ${ThemeColours.white};
    font-weight: ${FontWeight.BOLD};
  }
`;

export const LogoLink = styled(Link)`
  ${PRESSABLE};
  align-items: center;
  display: flex;
  flex: 1;
  flex: 0 0 auto;
  justify-content: left;
`;

export const Logo = styled(IconHealthEngine)`
  height: 32px;
  margin: 14px 24px 14px 0;
  width: 35px;
`;

export const WhiteLogo = styled(Logo)`
  fill: ${ThemeColours.white};
`;

export const TelehealthIcon = styled(IconTelehealthTopNav)`
  display: flex;
  margin-right: 4px;
`;

export const WhiteTelehealthIcon = styled(TelehealthIcon)`
  fill: ${ThemeColours.white};
`;

export const GPIcon = styled(IconGPTopNav)`
  display: flex;
  margin: -2px 4px -2px -2px;
`;

export const WhiteGPIcon = styled(GPIcon)`
  fill: ${ThemeColours.white};
`;

export const OverflowSpecialtyOptionVariant2 = styled(OverflowSpecialtyOption)`
  color: ${ThemeColours.white};

  &:hover {
    color: ${ThemeColours.white};
    font-weight: ${FontWeight.BOLD};
  }
`;
